<template>
    <div class="pub-panel-full" :class="[{'avoid-footer': isAvoidFooter}]">
        <pub-header :headTitle="headTitle" :isCustomMethod="true" @customMethod="customMethod"
        v-if="isShowHeader"></pub-header>
        <slot></slot>
    </div>
</template>
<style>
.pub-panel-full{
    width: 100%;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 900;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.pub-panel-full.avoid-footer{
    bottom: 1.06rem;
}
</style>
<script>
export default {
    props: {
        isShowHeader: { //是否显示页头
            type: Boolean,
            default: true
        },
        headTitle: { //页头标题
            type: String,
            default: ""
        },
        isAvoidFooter: { //是否避开页脚
            type: Boolean,
            default: false
        },
    },
    methods:{
        //自定义返回
        customMethod(){
            this.$emit("customMethod");
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/shared/components/control/panel-full.vue